import { RequiredFieldTooltip } from '@/shared/components/required-field-tooltip';
import { Checkbox, Field } from '@noorden-insurtech/alba-design-system';
import type { ReactNode } from 'react';
import type { TFieldContext } from '../types';

export type CheckboxFieldProps = {
  label: ReactNode;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
};

export function createCheckboxField(useFieldContext: () => unknown) {
  return function CheckboxField({
    label,
    required,
    disabled,
    onChange,
  }: CheckboxFieldProps) {
    const field = useFieldContext() as TFieldContext<boolean>;
    const hasError = field.state.meta.errors.length > 0;

    return (
      <RequiredFieldTooltip active={required}>
        <Field.Root invalid={hasError}>
          <Checkbox.Root
            disabled={disabled}
            checked={field.state.value || false}
            onCheckedChange={() => {}}
            onClick={() => {
              if (disabled) return;
              const current = field.state.value || false;
              field.handleChange(!current);
              onChange?.(!current);
            }}
          >
            <Checkbox.Control>
              <Checkbox.Indicator />
            </Checkbox.Control>
            <Checkbox.Label>
              {label}
              {required && <span className='text-alba-error-red-500'>*</span>}
            </Checkbox.Label>
          </Checkbox.Root>
          {hasError && (
            <Field.ErrorText>{field.state.meta.errors[0]}</Field.ErrorText>
          )}
        </Field.Root>
      </RequiredFieldTooltip>
    );
  };
}
